/**
 * @module tabsHover
 */

module.exports = function() {
    document.querySelectorAll('.tab').forEach(item => item.addEventListener('mouseover', function(e) {
       e.preventDefault();
       let tab = this,
           tabs = document.querySelectorAll('.tabs-wrapper');
       tabs.forEach(item => {
           let tabsItem = item.querySelector('.tab.active');
           if(tabsItem) tabsItem.classList.remove('active');
       });
       tab.classList.add('active');
    }))
}; // exports